module.exports = __webpack_public_path__ + "static/overview-d5f039d380d0ff186e368db3aa141ac7.png";